export const SITE_NAME = 'CSSBuy Spreadsheet';

export const LOGO_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

export const SITE_DESCRIPTION =
  'Find the CSSBuy Spreadsheet, buying guides, information about QC, warehouse, shipping, coupons and reviews. Compare options and find updated resources for your purchases.';

export function getSiteOrigin(): string {
  const env = (import.meta.env.VITE_SITE_URL as string | undefined) || '';
  if (env) return env.replace(/\/+$/, '');
  if (typeof window !== 'undefined' && window.location.origin) {
    return window.location.origin.replace(/\/+$/, '');
  }
  return '';
}

export function absoluteUrl(path: string): string {
  const origin = getSiteOrigin();
  if (!origin) return path.startsWith('/') ? path : `/${path}`;
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
}